import React from 'react';
import './Cali.css'; 

const Quibdo = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKUI.pdf" target="_blank" rel="noreferrer">Aeropuerto El Caraño</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 13</th>                      
          </tr>  
          
               
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 31</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2D.pdf" target="_blank" rel="noreferrer">ALBE2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2D.pdf" target="_blank" rel="noreferrer">GENG2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2D.pdf" target="_blank" rel="noreferrer">OPSA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2D.pdf" target="_blank" rel="noreferrer">VOVR2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2C.pdf" target="_blank" rel="noreferrer">ISRA2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2C.pdf" target="_blank" rel="noreferrer">TEDU2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2B.pdf" target="_blank" rel="noreferrer">ORIM1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2B.pdf" target="_blank" rel="noreferrer">ISRA2B</a></th>
          </tr>         
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/USEV1A.pdf" target="_blank" rel="noreferrer">USEV1A</a></th>
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/TEDU2D.pdf" target="_blank" rel="noreferrer">TEDU2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/EVMU1A.pdf" target="_blank" rel="noreferrer">EVMU1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/EVMU1A.pdf" target="_blank" rel="noreferrer">UTMI1A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 13</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">ALBE2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">GENG2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">ISRA2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">OPSA2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">TEDU2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">VOVR2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2F.pdf" target="_blank" rel="noreferrer">PABU1A</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 31</th>                      
          </tr>
          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/GENG2C.pdf" target="_blank" rel="noreferrer">GENG2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/GENG2C.pdf" target="_blank" rel="noreferrer">OPSA2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/GENG2C.pdf" target="_blank" rel="noreferrer">TEDU2A</a></th>
          </tr>
         <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2D.pdf" target="_blank" rel="noreferrer">UTMI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2D.pdf" target="_blank" rel="noreferrer">ISRA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2D.pdf" target="_blank" rel="noreferrer">OPSA2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ISRA2D.pdf" target="_blank" rel="noreferrer">TEDU2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2E.pdf" target="_blank" rel="noreferrer">ALBE2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2E.pdf" target="_blank" rel="noreferrer">GENG2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2E.pdf" target="_blank" rel="noreferrer">OPSA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2E.pdf" target="_blank" rel="noreferrer">VOVR2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ALBE2E.pdf" target="_blank" rel="noreferrer">ATOM1A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 13</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/RNP13.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 31</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ILSX31.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ILSY31.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/ILSZ31.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/RNP31.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/VORZ31.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/VORY31.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/LOCX31.pdf" target="_blank" rel="noreferrer">LOC X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKUI/LOCZ31.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>
          
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Quibdo;